var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.scrollFlag || _vm.isEnd)?_c('div',{staticClass:"lodingBox"},[(_vm.scrollFlag)?_c('div',[_c('Icon',{staticClass:"demo-spin-icon-load",attrs:{"type":"ios-loading","size":"18"}}),_c('span',[_vm._v("数据加载中，请稍后")])],1):_vm._e(),(_vm.isEnd)?_c('div',[_c('span',[_vm._v("数据加载完成，没有更多相关内容了")])]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }